@if(showMeteringFilter){
  <div class="sx-metering-scope__component">
    <header class="sx-metering-scope__header">

      <div class="sx-metering-scope__hotcoldwrapper">
        <div class="sx-metering-scope__section sx-metering-scope__section--rounded-left sx-metering-scope__section--hot" [hidden]="meteringType == 'Cold'">
          <svg class="sx-metering-scope__service-icon">
            <use xlink:href="#sx-varme" href="#sx-varme" />
          </svg>
          <!-- <span class="sx-metering-scope__service-text">{{ 'metering.filter.title_hot' | translate }}</span> -->
        </div>

        <div class="sx-metering-scope__section sx-metering-scope__section--rounded-left sx-metering-scope__section--cold" [hidden]="meteringType == 'Hot'">
          <svg class="sx-metering-scope__service-icon">
            <use xlink:href="#sx-kyla" href="#sx-kyla" />
          </svg>
          <!-- <span class="sx-metering-scope__service-text">{{ 'metering.filter.title_cold' | translate }}</span> -->
        </div>
      </div>

      <div class="sx-metering-scope__contentwrapper">
        <div class="sx-metering-scope__section sx-metering-scope__section--grow sx-metering-scope__titlewrapper" 
          [ngClass]="{'sx-metering-scope__section--rounded-right': meteringPointsCount === 1}">

          <div class="sx-metering-scope__header">

            @if(meteringPointsCount > 1 && (!filterSettings || filterSettings.filterType === filterSettingsTypeEnum.Unfiltered)){
              <h2 class="sx-metering-scope__heading">
                {{ 'metering.filter.all' | translate }}
              </h2>
            }
            <!-- En anläggning ej vald som filter - Visa anläggningsnamn -->
            @if(meteringPointsCount === 1 && (!filterSettings || filterSettings.filterType === filterSettingsTypeEnum.Unfiltered)){
              <h2 class="sx-metering-scope__heading">
                {{singleMeteringPointName}}
              </h2>
            }

            <!-- Grupp vald som filter - Visa namn på grupp -->
            @if(filterSettings && filterSettings.filterType !== filterSettingsTypeEnum.Unfiltered){
              <h2 class="sx-metering-scope__heading">
                {{filterSettings.name}}
              </h2>
            }

            <div class="sx-metering-scope__counttext">
              <!-- Filter satt - Visa subfilter -->
               @if(filterSettings && filterSettings.filterType !== filterSettingsTypeEnum.Unfiltered && meteringPointsCountLabel.trim().length > 0){
                <div [ngClass]="{'sx-metering-scope__subtitle': subfilterEnabled}" (click)="toggleSubFilter()">
                  <span [hidden]="subfilterEnabled">(</span>
                    {{meteringPointsCountLabel}} 
                    <span class="sx-metering-scope__counttext-long">{{ (filterSettings.subtitle !== "1" ? 'metering.filter.metering_points' : 'metering.filter.metering_point') | translate }}</span>
                    <span class="sx-metering-scope__counttext-short" aria-hidden="true">{{ 'metering.filter.no_of_metering_points' | translate }}</span>
                  <span [hidden]="subfilterEnabled">)</span>
                  @if(subfilterEnabled){
                    <div class="sx-metering-scope__subtitle-select-wrapper">
                      <div [className]="subfilterOpenState ? 'sx-metering-scope__subtitle-unselect' : 'sx-metering-scope__subtitle-select'"></div>
                    </div>
                  }
                </div>
               }

              <!-- Inget Filter satt - Fler än en anläggning -->
              @if(meteringPointsCount > 1 && (!filterSettings || filterSettings.filterType === filterSettingsTypeEnum.Unfiltered)){
                <div [ngClass]="{'sx-metering-scope__subtitle': subfilterEnabled}" (click)="toggleSubFilter()">
                    <span [hidden]="subfilterEnabled">(</span>
                    {{meteringPointsCountLabel}} 
                    <span class="sx-metering-scope__counttext-long">{{ 'metering.filter.subtitle' | translate }}</span>
                    <span class="sx-metering-scope__counttext-short" aria-hidden="true">{{ 'metering.filter.no_of_metering_points' | translate }}</span>
                    <span [hidden]="subfilterEnabled">)</span>
                    @if(subfilterEnabled){                      
                    <div class="sx-metering-scope__subtitle-select-wrapper">
                      <div [className]="subfilterOpenState ? 'sx-metering-scope__subtitle-unselect' : 'sx-metering-scope__subtitle-select'"></div>
                    </div>
                    }
                </div>
              }
            </div>
          </div>
        </div>

        <div class="sx-metering-scope__functionwrapper">
          @if(meteringPointsCount > 1){
            <div class="sx-metering-scope__section sx-metering-scope__section--rounded-right sx-metering-scope__section--padless ">
              <button appTrackClick sxaction="Configuration metering filter options" mat-button class="sx-metering-scope__button"
                id="metering_filter_more_options_btn"
                matTooltip="{{'core.button.more_options' | translate}}"
                [matMenuTriggerFor]="moreOptions" #moreOptionsTrigger="matMenuTrigger">  
                <svg style="transform: scale(0.9) !important;">
                  <use xlink:href="#sx-three-dots-vertical" href="#sx-three-dots-vertical" />
                </svg>
              </button>
              
              <mat-menu class="sx-account-menu" id="metering_filter_more_options" #moreOptions="matMenu" yPosition="below" overlapTrigger="false">
                <button mat-menu-item  class="sx-menu-item sxl-flex sxl-row" appTrackClick 
                  sxaction="Button configure metering filter"
                  id="metering_filter_configure_btn"
                  (click)="configureFilter()">
                  <mat-icon class="sx-menu-item__icon">
                    <svg>
                      <use xlink:href="#sx-andra-urval-for-matpunkter" href="#sx-andra-urval-for-matpunkter"></use>
                    </svg>
                  </mat-icon>
                  <span class="sx-metering-scope__buttontext-long">{{'metering.filter.edit' | translate}}</span>
                  <span class="sx-metering-scope__buttontext-short" aria-hidden="true">{{'metering.filter.edit' | translate}}</span>
                </button>
              </mat-menu>
            </div>
          }
        </div>
      </div>
    </header>
    @if(subfilterEnabled){
      <mat-expansion-panel #subfilterPanel
          (opened)="subfilterOpenState = true"
          (closed)="subfilterOpenState = true"
          class="sx-metering-scope__subfilter">
        @if(filterSettings && filterSettings.subfilter){
          <div>
            @if(filterSettings.subfilter.includedMeteringPoints){
              <div class="sx-metering-scope__subfilter__title">{{filterSettings.subfilter.title }}</div>
              <div class="sx-metering-scope__subfilter__grid">
                @for(mp of filterSettings.subfilter.includedMeteringPoints; track mp.id;){
                  <div class="sx-metering-scope__subfilter__point">
                    <mat-slide-toggle [checked]="mp.selected" (click)="toggleSelected(mp)">
                      <span>{{mp.name}}</span>
                      <span class="sxh-text-mp-id">({{mp.id}})</span>
                    </mat-slide-toggle>
                  </div>
                }
              </div>
            }
            @else {
              <div class="sx-metering-scope__subfilter__grid">
                @for(mp of filterSettings.subfilter.excludedMeteringPoints; track mp.id;){
                  <div class="sx-metering-scope__subfilter__point">
                    <mat-slide-toggle [checked]="mp.selected" (click)="toggleSelected(mp)">
                      <span>{{mp.name}}</span>
                      <span class="sxh-text-mp-id">({{mp.id}})</span>
                    </mat-slide-toggle>
                  </div>
                }
              </div>
            }
            @if(filterSettings.subfilter.includedMeteringPoints && filterSettings.subfilter.includedMeteringPoints.length > 0 && filterSettings.subfilter.excludedMeteringPoints.length > 0){
              <mat-expansion-panel 
                (opened)="panelOpenState = true" 
                (closed)="panelOpenState = false"
                class="sx-metering-scope__subfilter__expansion">
                <mat-expansion-panel-header class="sx-metering-scope__subfilter__expansion-header">
                  <mat-panel-title>
                    <div class="sx-metering-scope__subfilter__expansion-title">
                      {{ 'metering.filter.subfilter_not_included' | translate }}
                    </div>
                  </mat-panel-title>
                  <mat-panel-description></mat-panel-description>
                </mat-expansion-panel-header>
                <div class="sx-metering-scope__subfilter__grid">
                  @for(mp of filterSettings.subfilter.excludedMeteringPoints; track mp.id;){
                    <div class="sx-metering-scope__subfilter__point">
                      <mat-slide-toggle [checked]="mp.selected" (click)="toggleSelected(mp)">
                        <span>{{mp.name}}</span>
                        <span class="sxh-text-mp-id">({{mp.id}})</span>
                      </mat-slide-toggle>
                    </div>
                  }
                </div>
              </mat-expansion-panel>
            }

            <div class="sx-metering-scope__subfilter__footer">
              <div>
                <button mat-button class="sx-button sx-metering-scope__subfilter__button" (click)="resetSubfilter()">
                  {{ 'metering.filter.subfilter_reset' | translate }}
                </button>
                <button mat-button class="sx-button sx-metering-scope__subfilter__button"
                  (click)="toggleAllInSubfilter(true)">
                  {{ 'metering.filter.subfilter_select_all' | translate }}
                </button>
                <button mat-button class="sx-button sx-metering-scope__subfilter__button"
                  (click)="toggleAllInSubfilter(false)">
                  {{ 'metering.filter.subfilter_unselect_all' | translate }}
                </button>
              </div>
            </div>
          </div>
        }
      </mat-expansion-panel>
    }
  </div>
}

